// Reine Rechnung des Dialer-Countdowns (ohne React, mit node --test prüfbar), siehe countdown.ts.
/** So lange nach der letzten Eingabe am Lead bleibt der Countdown angehalten. */
export const RUHE_MS = 5000;

export interface CountdownStand {
  /** verbleibende Millisekunden */
  rest: number;
  gesamt: number;
  /** angehalten, weil am Lead gearbeitet wird */
  haelt: boolean;
}

/** Ein Rechenschritt: `dt` ms vergangen. Angehalten (Eingabe vor weniger als RUHE_MS oder Formular offen) zählt nichts ab. */
export function schritt(rest: number, dt: number, sinceEingabe: number, formularOffen: boolean): { rest: number; haelt: boolean } {
  const haelt = formularOffen || sinceEingabe < RUHE_MS;
  return { rest: haelt ? rest : Math.max(0, rest - dt), haelt };
}
